import { render, staticRenderFns } from "./add-rental-controls.vue?vue&type=template&id=772b16bd&scoped=true"
import script from "./add-rental-controls.vue?vue&type=script&lang=js"
export * from "./add-rental-controls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b16bd",
  null
  
)

export default component.exports